import { carrierIcons } from "../../../assets/icons";
import { STATUSES } from "../../../constants";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

function formatAddress(addr) {
  if (!addr) return null;

  const line1 =
    addr.address1 + (addr.address2 ? `, ${addr.address2}` : "");

  const cityState = [addr.city, addr.state?.name].filter(Boolean).join(", ");

  const postal = addr.zip

  const line2 = [
    cityState,
    postal,
    addr.country?.name
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className="space-y-2 text-sm">
      {/* Name */}
      {addr.name && (
        <div className="font-semibold text-gray-900">
          {addr.name}
        </div>
      )}

      {/* Address */}
      <div className="text-gray-700 leading-relaxed">
        <div>{line1}</div>
        <div className="text-gray-600">{line2}</div>
      </div>

      {/* Contact */}
      {(addr.phone || addr.email) && (
        <div className="pt-2 space-y-1 text-xs text-gray-500">
          {addr.phone && (
            <div>
              <span className="font-medium text-gray-600">Phone:</span>{" "}
              {addr.phone}
            </div>
          )}
          {addr.email && (
            <div>
              <span className="font-medium text-gray-600">Email:</span>{" "}
              {addr.email}
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export function ShipmentDetails({ order }) {
  return (
    <div className="rounded-xl border border-gray-200 bg-white p-6 sm:p-8 space-y-8">
      
      {/* Header */}
      <div className="flex items-start justify-between gap-6">
        <div className="flex items-center gap-4">
          <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-slate-100 text-[#0052FF]">
            {carrierIcons[order?.carrier?.carrierName]}
          </div>

          <div>
            <h3 className="text-lg font-semibold text-gray-900">
              {order.carrier?.carrierName}
            </h3>
            <p className="text-sm text-gray-500">
              {order?.carrier?.serviceName}
            </p>
          </div>
        </div>

        <span
          className={classNames(
            STATUSES[order.orderStatus],
            "px-3 py-1 text-xs font-medium rounded-full whitespace-nowrap"
          )}
        >
          {order.orderStatus}
        </span>
      </div>

      {/* Divider */}
      <div className="border-t border-gray-200" />

      {/* Addresses */}
      <div className="grid md:grid-cols-2 gap-6">
        
        {/* Sender */}
        <div className="rounded-xl border border-gray-200 p-5">
          <div className="flex items-center gap-3 mb-4">
            <span className="text-xs font-semibold uppercase tracking-wide text-gray-500">
              Sender
            </span>
            <div className="flex-1 border-t border-gray-200" />
          </div>

          {formatAddress(order.from)}
        </div>

        {/* Receiver */}
        <div className="rounded-xl border border-gray-200 p-5">
          <div className="flex items-center gap-3 mb-4">
            <span className="text-xs font-semibold uppercase tracking-wide text-gray-500">
              Receiver
            </span>
            <div className="flex-1 border-t border-gray-200" />
          </div>

          {formatAddress(order.to)}
        </div>
      </div>
    </div>
  );
}